import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import apiClient from '../apiClient/apiClient';
import { StoreInfoRecord } from './StoreInfo.type';

export const useStoreInfo = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<StoreInfoRecord[]>>({
    queryKey: 'storeInfo',
    queryFn: () => apiClient.get<StoreInfoRecord[]>('/store-info'),
    enabled,
  });
};